import {
  HubConnectionBuilder,
  HubConnection,
  HubConnectionState,
  LogLevel,
} from '@microsoft/signalr';
import { apiConfig } from '../client/config';
import { AUTH_TOKEN_KEY } from '../client/config';
import type { RealTimeNotification } from '../types/notification';

let connection: HubConnection | null = null;

function getAccessToken(): string {
  return localStorage.getItem(AUTH_TOKEN_KEY) ?? '';
}

function buildHubUrl(): string {
  const base = apiConfig.baseURL.replace(/\/+$/, '');
  return `${base}/hubs/notifications`;
}

export function getNotificationConnection(): HubConnection {
  if (!connection) {
    connection = new HubConnectionBuilder()
      .withUrl(buildHubUrl(), { accessTokenFactory: getAccessToken })
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Warning)
      .build();
  }
  return connection;
}

export async function startNotificationHub(): Promise<HubConnection> {
  const hub = getNotificationConnection();
  if (hub.state === HubConnectionState.Disconnected) {
    await hub.start();
  }
  return hub;
}

export async function stopNotificationHub(): Promise<void> {
  if (connection && connection.state !== HubConnectionState.Disconnected) {
    await connection.stop();
  }
  connection = null;
}

export function onReceiveNotification(
  callback: (notification: RealTimeNotification) => void,
): void {
  const hub = getNotificationConnection();
  hub.on('ReceiveNotification', callback);
}

export function offReceiveNotification(
  callback: (notification: RealTimeNotification) => void,
): void {
  const hub = getNotificationConnection();
  hub.off('ReceiveNotification', callback);
}
